/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { TreeView } from '@neo4j-ndl/react';
import type React from 'react';
import { useState } from 'react';

const TREE_ITEMS: React.ComponentProps<typeof TreeView>['items'] = [
  {
    canHaveSubItems: true,
    data: {
      actions: [],
      text: 'Folder 1',
    },
    id: 'Folder 1',
    isCollapsed: false,
    isSelected: false,
    subItems: [
      {
        canHaveSubItems: false,
        data: {
          actions: [],
          text: 'Item 1',
        },
        id: 'Item 1',
        isSelected: false,
      },
      {
        canHaveSubItems: true,
        data: {
          actions: [],
          text: 'Folder 2',
        },
        id: 'Folder 2',
        isCollapsed: false,
        isSelected: false,
        isSkeletonLoading: true,
        subItems: [
          {
            canHaveSubItems: false,
            data: {
              actions: [],
              text: 'Item 2',
            },
            id: 'Item 2',
            isSelected: false,
          },
          {
            canHaveSubItems: false,
            data: {
              actions: [],
              text: 'Item 3',
            },
            id: 'Item 3',
            isSelected: false,
            isSkeletonLoading: true,
          },
        ],
      },
    ],
  },
];

const Component = () => {
  const [items, setItems] =
    useState<React.ComponentProps<typeof TreeView>['items']>(TREE_ITEMS);

  return (
    <TreeView
      items={items}
      onItemsChanged={(newItems, itemChangedReason) => {
        console.info('change with itemChangedReason:', itemChangedReason);
        setItems(newItems);
      }}
      TreeItemComponent={undefined}
    />
  );
};

export default Component;
